/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap('<div class="widescreen responsive-embed"/>');
		} else {
		  jQuery(this).wrap('<div class="responsive-embed"/>');
		}
	});

	/**
   * Site wide
   */
  
  jQuery(window).scroll(function(){

    // smaller header on scroll
    if(jQuery(document).scrollTop() > 100) {
      jQuery('header').addClass('smaller');
    } else {
      jQuery('header').removeClass('smaller');
    }

    // slide in scroll to top button
    if (jQuery(window).scrollTop() + jQuery(window).height() > (jQuery(document).height() - 100)) {
      jQuery('.scroll-top').addClass('in');
    } else {
      jQuery('.scroll-top').removeClass('in');
    }
  });

  // search modal
  jQuery('.btn-navbar-search').click(function(e) {
    e.preventDefault();
    jQuery('.searchform-overlay').toggleClass('in');
    jQuery('#s').focus();
  });

  // click body to close search modal
  jQuery(document).mouseup(function (e) {
      var container = jQuery('#searchform');
      var overlay = jQuery('.searchform-overlay');

      // if the target of the click isn't the container
      // nor a descendant of the container
      if (!container.is(e.target) 
        && container.has(e.target).length === 0) {
        if (overlay.hasClass('in')) {
          overlay.removeClass('in');
        }
      }
  });

  // scroll top
  jQuery('.scroll-top').click(function(e) {
    e.preventDefault();
    jQuery('html, body').animate({
      scrollTop: 0
    }, 850);
  });

  //-------------------------- 
  var _body = jQuery('body');
  //--------------------------

});
